import { autocompleteCategoriesStyles } from "@insite/content-library/Widgets/Header/AutocompleteCategories";
import getProp from "@insite/mobius/utilities/getProp";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import { css } from "styled-components";

Object.assign(autocompleteCategoriesStyles, {
    headerText: {
        css: css`
            text-align: left;
            margin: 0 0 16px 0;
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            font-size: ${TYPOGRAPHY.size.smaller};
            line-height: 16px;
            color: ${getProp("theme.typography.p.color")};
            text-transform: uppercase;
        `,
    },
    categoryItemText: {
        ellipsis: true,
        css: css`
            // margin-bottom: 16px;
        `,
    },
    link: {
        typographyProps: {
            ellipsis: true,
            css: css`
                width: 100%;
                text-align: left;
                margin: 0;
                font-weight: ${TYPOGRAPHY.weight.base};
                font-size: ${TYPOGRAPHY.size.smaller};
                line-height: 20px;
                color: ${COLORS.background.tag} !important;
                padding-bottom: 16px;
            `,
        },
        css: css`
            width: auto;
            overflow: hidden;
        `,
    },
});
